import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
//import { useRef } from 'react'
import { useForm, ValidationError } from '@formspree/react';
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const [state, handleSubmit] = useForm("mlekdkne");
  if (state.succeeded) {
      return <p>Thanks for joining!</p>;
  }
  
  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            Estoy interesado en oportunidades independientes, especialmente en ambiciosos
          o grandes proyectos. Sin embargo, si tiene otras solicitudes o
          Si tiene alguna pregunta, no dude en ponerse en contacto conmigo utilizando el siguiente formulario.
          </p>
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <label htmlFor="email">
                    Email Address
              </label>
                <input 
                  id="email"
                  type="email" 
                  name="email"
                />
                <ValidationError 
                  prefix="Email" 
                  field="email"
                  errors={state.errors}
                />
                <label>
                    Message:
                </label>
                <textarea
                  id="message"
                  name="message"
                />
                <ValidationError 
                  prefix="Message" 
                  field="message"
                  errors={state.errors}
                />
                <button type="submit" className="flat-button" disabled={state.submitting}>
                  Submit
                </button>
            </form>
          </div>
        </div>
        <div className="info-map">
          Daniel Leon,
          <br />
          Chile,
          <br />
          Downtown <br />
          Santiago <br />
          <br />
          <span>danielvleonf@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[-33.44237351984247, -70.65812237116371]} zoom={13}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[-33.44237351984247, -70.65812237116371]}>
              <Popup>Vivo aca, ven por un par de tazas de cafe :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact